import { ComponentProps } from 'react'

import { joinStyles } from '@/utils/app/theme'

import { ColorDot, SizeDot } from '@/types/ui/dot'
import * as styles from './index.css'

type DotProperties = ComponentProps<'div'> & {
    size?: SizeDot
    color?: ColorDot
}

/** Dot UI component. */
export const Dot = ({
    className,
    size = 'medium',
    color = 'success',
    ...properties
}: Readonly<DotProperties>) => {
    return (
        <div
            className={joinStyles(
                styles.base,
                styles.size[size],
                styles.color[color],
                className,
            )}
            {...properties}
        />
    )
}
